import { UploadFile } from 'antd';
import { Dayjs } from 'dayjs';
import { FicheDeLiaison } from 'types/User';

export type RAI = '3.1' | '3.2';

export enum VehiculeType {
  LEGER = 'Véhicule léger ou utilitaire léger (M1, N1, N2 avec dérogation de poids)',
  LOURD = 'Véhicule lourd (N2 ou N3)',
  BUS = 'Autocar ou autobus (M2 ou M3)',
}

export enum CategorieVehicule {
  M1 = 'M1',
  N1 = 'N1',
  N2 = 'N2 sous dérogation de poids',
}

export enum CategorieVehiculeLourd {
  CAMION_3_5_A_4_25 = 'Camion porteur > 3,5 tonnes et < 4,25 tonnes',
  CAMION_4_25_A_7_5 = 'Camion porteur ≥ 4,25 tonnes et < 7,5 tonnes',
  CAMION_7_5_A_12 = 'Camion porteur ≥ 7,5 tonnes et ≤ 12 tonnes',
  CAMION_12_A_19 = 'Camion porteur > 12 tonnes et < 19 tonnes',
  CAMION_19_A_26 = 'Camion porteur ≥ 19 tonnes et < 26 tonnes',
  CAMION_26_ET_TRACTEUR = 'Camion porteur ≥ 26 tonnes et tracteur routier',
  BENNE_AGGLO_MOINS_250 = 'Benne à ordures ménagères (agglomération ≤ 250 000 habitants)',
  BENNE_AGGLO_PLUS_250 = 'Benne à ordures ménagères (agglomération > 250 000 habitants)',
}

export enum CategorieVehiculeBus {
  AUTOBUS_STANDARD_AGGLO_MOINS_250 = 'Autobus standard (agglomération ≤ 250 000 habitants)',
  AUTOBUS_STANDARD_AGGLO_PLUS_250 = 'Autobus standard (agglomération > 250 000 habitants)',
  AUTOCAR_STANDARD_AUTRE = 'Autocar standard (autre personne morale)',
  AUTOBUS_GRANDE_CAPACITE_AGGLO_MOINS_250 = 'Autobus grande capacité (agglomération ≤ 250 000 habitants)',
  AUTOBUS_GRANDE_CAPACITE_AGGLO_PLUS_250 = 'Autobus grande capacité (agglomération > 250 000 habitants)',
  AUTOCAR_GRANDE_CAPACITE_AUTRE = 'Autocar grande capacité (autre personne morale)',
}

export enum ClientType {
  PERSONNE_PHYSIQUE = 'Personne physique',
  PERSONNE_MORALE = 'Personne morale',
}

export enum statutPrecarite {
  MODESTE = 'Modeste',
  PRECAIRE = 'Précaire',
}

export enum YesOrNo {
  OUI = 'Oui',
  NON = 'Non',
}

export enum UsageVehicule {
  FONCTION = 'fonction',
  LOCATION_COURTE = 'location_courte',
  LOCATION_LONGUE = 'location_longue',
}

export enum UsageVehiculeParticulier {
  ACHAT = 'Achat d’un ou plusieurs véhicules légers ou véhicules utilitaires légers électriques neufs',
  LOCATION = 'Location d’un ou plusieurs véhicules légers ou véhicules utilitaires légers électriques neufs',
  RETROFIT_LEGER = 'Rétrofit électrique d’un ou plusieurs véhicules légers',
  RETROFIT_UTILITAIRE = 'Rétrofit électrique d’un ou plusieurs véhicules utilitaires légers',
}

export enum UsageVehiculeLourd {
  ACHAT = "Achat d'un ou plusieurs véhicules lourds électriques neufs",
  LOCATION = "Location d'un ou plusieurs véhicules lourds électriques neufs",
  RETROFIT = "Rétrofit électrique d'un ou plusieurs véhicules lourds électriques neufs",
}

export enum UsageAutobus {
  ACHAT = "Achat d'un ou plusieurs autocars ou autobus électriques neufs",
  LOCATION = "Location d'un ou plusieurs autocars ou autobus électriques neufs",
  RETROFIT = "Rétrofit électrique d'un ou plusieurs autocars ou autobus électriques neufs",
}

export enum TypeClientLourd {
  AGGLO_MOINS_250 = 'Agglomération ≤ 250 000 habitants',
  AGGLO_PLUS_250 = 'Agglomération > 250 000 habitants',
  AUTRE = 'Autre personne morale',
}
export enum TypeStructure {
  Association = 'association',
  BailleurSocial = 'bailleur_social',
  CollectiviteTerritoriale = 'collectivite_territoriale',
  PromoteurPrive = 'promoteur_prive',
  SyndicDeCopropriete = 'syndic_de_copropriete',
  SCI = 'sci',
  EntreprisePrivee = 'entreprise_privee',
  Autre = 'autre',
}

export const usageParticulierParCategories: Record<
  CategorieVehicule,
  UsageVehiculeParticulier[]
> = {
  [CategorieVehicule.M1]: [
    UsageVehiculeParticulier.ACHAT,
    UsageVehiculeParticulier.LOCATION,
    UsageVehiculeParticulier.RETROFIT_LEGER,
  ],
  [CategorieVehicule.N1]: [
    UsageVehiculeParticulier.ACHAT,
    UsageVehiculeParticulier.LOCATION,
    UsageVehiculeParticulier.RETROFIT_UTILITAIRE,
  ],
  [CategorieVehicule.N2]: [
    UsageVehiculeParticulier.ACHAT,
    UsageVehiculeParticulier.LOCATION,
    UsageVehiculeParticulier.RETROFIT_UTILITAIRE,
  ],
};

export const usageLourdParCategories: Record<
  CategorieVehiculeLourd | CategorieVehiculeBus,
  UsageVehiculeLourd[] | UsageAutobus[]
> = {
  [CategorieVehiculeLourd.CAMION_3_5_A_4_25]: [
    UsageVehiculeLourd.ACHAT,
    UsageVehiculeLourd.LOCATION,
    UsageVehiculeLourd.RETROFIT,
  ],
  [CategorieVehiculeLourd.CAMION_4_25_A_7_5]: [
    UsageVehiculeLourd.ACHAT,
    UsageVehiculeLourd.LOCATION,
    UsageVehiculeLourd.RETROFIT,
  ],
  [CategorieVehiculeLourd.CAMION_7_5_A_12]: [
    UsageVehiculeLourd.ACHAT,
    UsageVehiculeLourd.LOCATION,
    UsageVehiculeLourd.RETROFIT,
  ],
  [CategorieVehiculeLourd.CAMION_12_A_19]: [
    UsageVehiculeLourd.ACHAT,
    UsageVehiculeLourd.LOCATION,
    UsageVehiculeLourd.RETROFIT,
  ],
  [CategorieVehiculeLourd.CAMION_19_A_26]: [
    UsageVehiculeLourd.ACHAT,
    UsageVehiculeLourd.LOCATION,
    UsageVehiculeLourd.RETROFIT,
  ],
  [CategorieVehiculeLourd.CAMION_26_ET_TRACTEUR]: [
    UsageVehiculeLourd.ACHAT,
    UsageVehiculeLourd.LOCATION,
    UsageVehiculeLourd.RETROFIT,
  ],
  [CategorieVehiculeLourd.BENNE_AGGLO_MOINS_250]: [
    UsageVehiculeLourd.ACHAT,
    UsageVehiculeLourd.LOCATION,
    UsageVehiculeLourd.RETROFIT,
  ],
  [CategorieVehiculeLourd.BENNE_AGGLO_PLUS_250]: [
    UsageVehiculeLourd.ACHAT,
    UsageVehiculeLourd.LOCATION,
    UsageVehiculeLourd.RETROFIT,
  ],
  [CategorieVehiculeBus.AUTOBUS_STANDARD_AGGLO_MOINS_250]: [
    UsageAutobus.ACHAT,
    UsageAutobus.LOCATION,
    UsageAutobus.RETROFIT,
  ],
  [CategorieVehiculeBus.AUTOBUS_STANDARD_AGGLO_PLUS_250]: [
    UsageAutobus.ACHAT,
    UsageAutobus.LOCATION,
    UsageAutobus.RETROFIT,
  ],
  [CategorieVehiculeBus.AUTOCAR_STANDARD_AUTRE]: [
    UsageAutobus.ACHAT,
    UsageAutobus.LOCATION,
    UsageAutobus.RETROFIT,
  ],
  [CategorieVehiculeBus.AUTOBUS_GRANDE_CAPACITE_AGGLO_MOINS_250]: [
    UsageAutobus.ACHAT,
    UsageAutobus.LOCATION,
    UsageAutobus.RETROFIT,
  ],
  [CategorieVehiculeBus.AUTOBUS_GRANDE_CAPACITE_AGGLO_PLUS_250]: [
    UsageAutobus.ACHAT,
    UsageAutobus.LOCATION,
    UsageAutobus.RETROFIT,
  ],
  [CategorieVehiculeBus.AUTOCAR_GRANDE_CAPACITE_AUTRE]: [
    UsageAutobus.ACHAT,
    UsageAutobus.LOCATION,
    UsageAutobus.RETROFIT,
  ],
};

export interface NouveauDossierConcessionnaireBase {
  typeClientFinal: ClientType;
  vehiculeType?: VehiculeType;
  typeClientLourd?: TypeClientLourd;
  statutPrecarite: statutPrecarite;
  avisImposition: UploadFile[];
  scoreEnvironnementalAtteint: YesOrNo;
  coutAcquisitionInferieur47000: YesOrNo;
  masseVehiculeInferieure2400: YesOrNo;
  dejaBeneficieBonusEcologique: YesOrNo;
  produitEnEurope: YesOrNo;
  vehiculeAdeme: YesOrNo;
  adresse: string;
  ville: string;
  codePostal: string;
  fonction: string;
  typeStructure?: TypeStructure;
  typeAcheteur:
    | 'company_less_100'
    | 'company_more_100'
    | 'org_less_20'
    | 'org_more_20'
    | 'loueur_ou_vendeur';
  nbDevis: string;
  dateDevis?: Dayjs;
  dateEditionDevis?: Dayjs;
  datePrevisionnelleDevis?: Dayjs;
  dateLivraison: Dayjs;
  email: string;
  raisonSociale: string;
  etablissement: string;
  firstname: string;
  lastname: string;
  phone: string;
  siret: string;
  nbVehicules: number;
  accountId?: string;
  usageVehicules?: UsageVehicule | UsageVehiculeLourd | UsageAutobus;
  usageVehiculeParticulier: UsageVehiculeParticulier;
  categorieVehicule: CategorieVehicule | CategorieVehiculeLourd;
  repartition: number;
  primeParVehicule: number;
  primeParGwh: number;
  volume: number;
  isVehiculeDemonstration?: boolean;
  ficheDeLiaison?: FicheDeLiaison;
}

export interface NouveauDossierConcessionnaireData
  extends NouveauDossierConcessionnaireBase {
  devis: UploadFile[];
  otherFiles: UploadFile[];
}

export interface NouveauDossierConcessionnaireParams
  extends Omit<
    NouveauDossierConcessionnaireBase,
    | 'dateEditionDevis'
    | 'dateDevis'
    | 'dateLivraison'
    | 'datePrevisionnelleDevis'
    | 'scoreEnvironnementalAtteint'
    | 'coutAcquisitionInferieur47000'
    | 'masseVehiculeInferieure2400'
    | 'dejaBeneficieBonusEcologique'
    | 'produitEnEurope'
    | 'vehiculeAdeme'
    | 'ficheDeLiaison'
  > {
  dateEditionDevis?: string;
  dateDevis?: string;
  dateLivraison: string;
  datePrevisionnelleDevis?: string;
  scoreEnvironnementalAtteint?: boolean;
  coutAcquisitionInferieur47000?: boolean;
  masseVehiculeInferieure2400?: boolean;
  dejaBeneficieBonusEcologique?: boolean;
  produitEnEurope?: boolean;
  vehiculeAdeme?: boolean;
  ficheDeLiaisonId?: string;
  rai?: RAI;
}

export type CalculPrimeConcessionnaireParams = Pick<
  NouveauDossierConcessionnaireBase,
  'typeAcheteur' | 'categorieVehicule' | 'typeClientFinal' | 'usageVehicules'
> & { ficheDeLiaisonId: string };

export type CalculPrimeParticulierConsessionnaireParams = {
  typeClientFinal: ClientType;
  categorieVehicule: CategorieVehicule;
  scoreEnvironnementalAtteint?: boolean;
  coutAcquisitionInferieur47000?: boolean;
  masseVehiculeInferieure2400?: boolean;
  dejaBeneficieBonusEcologique?: boolean;
  produitEnEurope?: boolean;
  vehiculeAdeme?: boolean;
  datePrevisionnelleDevis: Dayjs;
  codePostal: string;
  usageVehiculeParticulier: UsageVehiculeParticulier;
  statutPrecarite: statutPrecarite;
};

export interface PrimesConcessionnaire {
  M1: {
    company_less_100: {
      primeParVehicule: number | null;
      primeParGwh: number | null;
    };
    company_more_100: {
      primeParVehicule: number | null;
      primeParGwh: number | null;
    };
    org_less_20: {
      primeParVehicule: number | null;
      primeParGwh: number | null;
    };
    org_more_20: {
      primeParVehicule: number | null;
      primeParGwh: number | null;
    };
  };
  N1: {
    company_less_100: {
      primeParVehicule: number | null;
      primeParGwh: number | null;
    };
    company_more_100: {
      primeParVehicule: number | null;
      primeParGwh: number | null;
    };
    org_less_20: {
      primeParVehicule: number | null;
      primeParGwh: number | null;
    };
    org_more_20: {
      primeParVehicule: number | null;
      primeParGwh: number | null;
    };
  };
}

export interface ConcessionnaireFormAHData {
  reference: string;
  date: Dayjs | null;
  dateDevis?: Dayjs | null;
  bonCommande: UploadFile[];
  facture: UploadFile[];
  certificat: UploadFile[];
  autresDocuments?: UploadFile[];
  attestationDeTransformation?: UploadFile[];
  premierCertificatImmatriculation?: UploadFile[];
  recepisseFinDemonstration?: UploadFile[];
  immatriculation: string;
  identification: string;
  typeVarianteVersion: string;
  lastname: string;
  firstname: string;
  telephone: string;
  email: string;
}
